import { useQuery } from '@tanstack/react-query';

import { PayStationMonitoringStatus } from 'src/features/monitoring/types';
import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { STORAGE_PREFIX } from 'src/config';

const RESOURCE = `${STORAGE_PREFIX}/:parkingId/monitoring/pay-station/:payStationId/`;

type QueryFnType = typeof queryFn;

interface DTO {
    parkingId: string;
    payStationId: string;
}
const queryFn = ({ parkingId, payStationId }: DTO): Promise<PayStationMonitoringStatus> => {
    return axios.get(formatResourcePath(RESOURCE, { payStationId, parkingId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload.payStationId],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetPayStationStatus, RESOURCE as GET_PAY_STATION_STATUS_RESOURCE };
